export const BASE_URL = "https://twotixx.com:83/api";
export const BASE_IMAGE_URL = "https://twotixx.com:83";
export const GOOGLE_API_KEY = "AIzaSyA353ozQ1eG_fcl6pzjnYtcflqJpxrAKac";
